import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Privilege extends Base implements EntityType {
    privilegeId: uuid;
    name: string;
    description?: string | null;
    constructor(doc: typeof Privilege | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            privilegeId: genUUID(),
            name: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "privilege";
        // @ts-ignore
        this.privilegeId = doc._privilegeId || doc.privilegeId || doc.privilegeid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.description = doc._description || doc.description || null;
    }
    get id(): uuid { return this.privilegeId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for a privilege"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.privilegeId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Privilege[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'privilege',
    table: 'PRIVILEGES',
    comment: 'A privilege is an atomic access-control token that grants permission to a protected area of the interface or a specific class of data. Privileges are collected into roles, which are then assigned to users and groups to control what each user can see and do in the application.',
    fields: {
        privilegeId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for a privilege'
        },
        name: {type: 'string', required: true, comment: 'The name of the privilege'},
        description: {type: 'string', comment: 'Short description of the privilege'}
    }
});
    }
}
export default Privilege;
